"use client";

import { Logo } from "@/components/Logo";
import { getSiteInfo } from "@/sites";

import { StepperNavBarProps } from "./types";

import "./styles.scss";

const { siteName, siteLogoIcon } = getSiteInfo(process.env.NEXT_PUBLIC_DOMAIN!) || {};

export const StepperNavBar = ({ logoHref, stepper, menu }: StepperNavBarProps) => {
  const logoSrc = siteLogoIcon;

  return (
    <div
      className="StepperNavBar"
      data-testid="stepper-nav-bar"
    >
      <div className="StepperNavBar__logo">
        <Logo
          href={logoHref}
          src={logoSrc}
          siteName={siteName}
          dataQa="stepper-nav-bar-logo-link"
          dataTestId="stepper-nav-bar-logo"
          className="StepperNavBar__logo-image"
          width={32}
          height={32}
          loading="eager"
        />
      </div>

      <div className="StepperNavBar__stepper">{stepper}</div>

      {menu ? (
        <div className="StepperNavBar__menu">{menu}</div>
      ) : (
        <div className="StepperNavBar__menu-spacer" />
      )}
    </div>
  );
};
